const invoiceActionTypes = {
  GET_QBOAUTH: 'GET_QBOAUTH',
  SET_REDIRECTURL: 'SET_REDIRECTURL',
  GET_INVOICE_LIST: 'GET_INVOICE_LIST',
  SET_ERROR: 'SET_ERROR',
  SET_INVOICE_LIST: 'SET_INVOICE_LIST',
  SET_INVOICE_LIST_ERROR: 'SET_INVOICE_LIST_ERROR',
  GET_INVOICE_PDF: 'GET_INVOICE_PDF',
  SET_PDF_LOADING: 'SET_PDF_LOADING',
  SET_INVOICE_PDF: 'SET_INVOICE_PDF',
  SEND_DISPUTE: 'SEND_DISPUTE',
  SEND_DISPUTE_SUCCESS: 'SEND_DISPUTE_SUCCESS',
  SEND_DISPUTE_ERROR: 'SEND_DISPUTE_ERROR',
  CLEAR_DISPUTE_SUCCESS: 'CLEAR_DISPUTE_SUCCESS',
  FETCH_INVOICE_POLICY: 'FETCH_INVOICE_POLICY',
  SET_INVOICE_POLICY: 'SET_INVOICE_POLICY',
  SEARCH_INVOICE_NUMBER: 'SEARCH_INVOICE_NUMBER',
  SEARCH_SPINNER: 'SEARCH_SPINNER',
  GET_INVOICE_LINE_LIST: 'GET_INVOICE_LINE_LIST',
  SET_INVOICE_LINE_LIST: 'SET_INVOICE_LINE_LIST',
  SET_INVOICE_LINE_LIST_ERROR: 'SET_INVOICE_LINE_LIST_ERROR',
  GET_INVOICE_DISPUTE_HISTORY_LIST: 'GET_INVOICE_DISPUTE_HISTORY_LIST',
  SET_INVOICE_DISPUTE_HISTORY_LIST: 'SET_INVOICE_DISPUTE_HISTORY_LIST',
  SET_INVOICE_DISPUTE_HISTORY_LIST_ERROR: 'SET_INVOICE_DISPUTE_HISTORY_LIST_ERROR',
  GET_INVOICE_DETAIL: 'GET_INVOICE_DETAIL',
  SET_INVOICE_DETAIL: 'SET_INVOICE_DETAIL',
  SET_INVOICE_DETAIL_ERROR: 'SET_INVOICE_DETAIL_ERROR',
};

export default invoiceActionTypes;
